import React, { useState } from "react";
import {
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt,
  FaCheckCircle,
} from "react-icons/fa";
import "./Contact.css";

import SEO from "../components/SEO";
import SocialLinks from "../components/SocialLinks";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    business: "",
    phone: "",
    email: "",
    service: "",
  });

  const trackButtonClick = (label) => {
    if (window.gtag) {
      window.gtag("event", "cta_click", {
        event_category: "engagement",
        event_label: label,
      });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `
*FREE CONSULTATION REQUEST*

Name: ${formData.name}

Business Name: ${formData.business}

Phone Number: ${formData.phone}

Email: ${formData.email}

Service Needed:
${formData.service}
`;

    const whatsappURL = `https://wa.me/254775137928?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");

    trackButtonClick("WhatsApp Consultation Form");
  };

  return (
    <main className="contact-page">

      <link
  rel="canonical"
  href="https://satimatechnova.co.ke/contact/"
/>

      <SEO
        title="Contact Us"
        description="Get a FREE Digital Growth Consultation. Discover how your business can attract more leads, increase sales and grow online."
        url="https://satimatechnova.co.ke/contact/"
        image="https://satimatechnova.co.ke/images/contact-banner.png"
      />

      {/* HERO */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Ready to Get More Customers Online?</h1>

          <p>
            Book a FREE 15-Minute Digital Growth Consultation and discover how
            your business can attract more leads, increase sales, and grow
            online.
          </p>

          <div className="offer-grid">
            <div>
              <FaCheckCircle /> Free Website Audit
            </div>

            <div>
              <FaCheckCircle /> Free SEO Analysis
            </div>

            <div>
              <FaCheckCircle /> Free Social Media Review
            </div>

            <div>
              <FaCheckCircle /> Free Digital Marketing Consultation
            </div>
          </div>

          <div className="urgency-box">
            ⚡ Limited consultation slots available each month.
          </div>

          <a
            href="https://wa.me/254775137928"
            target="_blank"
            rel="noopener noreferrer"
            className="primary-btn"
            onClick={() =>
              trackButtonClick("Hero Free Consultation WhatsApp")
            }
          >
            Claim My Free Business Audit
          </a>
        </div>
      </section>

      {/* FORM */}
      <section className="form-section">
        <div className="form-card">
          <h2>Tell Us About Your Business</h2>

          <p>
            Complete the form below and we'll contact you within 24 hours.
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              onChange={handleChange}
            />

            <input
              type="text"
              name="business"
              placeholder="Business Name"
              required
              onChange={handleChange}
            />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              required
              onChange={handleChange}
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              required
              onChange={handleChange}
            />

            <textarea
              rows="5"
              name="service"
              placeholder="What help do you need?"
              required
              onChange={handleChange}
            ></textarea>

            <button type="submit">
              Get My Free Consultation
            </button>
          </form>
        </div>
      </section>

      {/* PROCESS */}
      <section className="process-section">
        <h2>What Happens After You Contact Us?</h2>

        <div className="process-grid">
          <div className="process-card">
            <span>1</span>
            <h3>Inquiry Review</h3>
            <p>We carefully review your inquiry and business needs.</p>
          </div>

          <div className="process-card">
            <span>2</span>
            <h3>Quick Consultation</h3>
            <p>We schedule a short consultation to understand your goals.</p>
          </div>

          <div className="process-card">
            <span>3</span>
            <h3>Growth Analysis</h3>
            <p>We identify opportunities to improve your online presence.</p>
          </div>

          <div className="process-card">
            <span>4</span>
            <h3>Recommendations</h3>
            <p>
              We recommend the most effective strategy for your business.
            </p>
          </div>
        </div>
      </section>



      
      <section className="dn-testimonial-section">

  <div className="dn-testimonial-header">
    <p className="dn-testimonial-badge">
      Client Testimonials
    </p>

    <h2 className="dn-testimonial-title">
      Trusted By Growing Businesses
    </h2>

    <p className="dn-testimonial-subtitle">
      We focus on delivering websites, branding, and digital marketing solutions
      that help businesses grow and stand out online.
    </p>
  </div>

  <div className="dn-testimonial-scroll">

    {/* TESTIMONIAL 1 */}
    <div className="dn-testimonial-card">
      <div className="dn-testimonial-stars">★★★★★</div>

      <p className="dn-testimonial-text">
        “The website exceeded our expectations and the digital marketing support
        has greatly improved our online visibility and customer engagement.”
      </p>

      <div className="dn-testimonial-client">
        <h4>Online Shop Client</h4>
        <span>E-commerce Business</span>
      </div>
    </div>

    {/* TESTIMONIAL 2 */}
    <div className="dn-testimonial-card">
      <div className="dn-testimonial-stars">★★★★★</div>

      <p className="dn-testimonial-text">
        “Professional website design, fast delivery, and excellent optimization.
        We now have a stronger and more credible online presence.”
      </p>

      <div className="dn-testimonial-client">
        <h4>Healthcare Client</h4>
        <span>Medical & Wellness Industry</span>
      </div>
    </div>

    {/* TESTIMONIAL 3 */}
    <div className="dn-testimonial-card">
      <div className="dn-testimonial-stars">★★★★★</div>

      <p className="dn-testimonial-text">
        “The redesigned website looks modern, loads faster, and performs much
        better on search engines than before.”
      </p>

      <div className="dn-testimonial-client">
        <h4>Business Consulting Client</h4>
        <span>Professional Services</span>
      </div>
    </div>

    {/* TESTIMONIAL 4 */}
    <div className="dn-testimonial-card">
      <div className="dn-testimonial-stars">★★★★★</div>

      <p className="dn-testimonial-text">
        “Our social media pages are now more consistent, professional, and engaging.
        We’ve seen better audience interaction over time.”
      </p>

      <div className="dn-testimonial-client">
        <h4>Technology Brand</h4>
        <span>Social Media Management</span>
      </div>
    </div>

    {/* TESTIMONIAL 5 */}
    <div className="dn-testimonial-card">
      <div className="dn-testimonial-stars">★★★★★</div>

      <p className="dn-testimonial-text">
        “Great communication, strong branding ideas, and reliable support throughout
        the project. Highly recommended.”
      </p>

      <div className="dn-testimonial-client">
        <h4>Corporate Client</h4>
        <span>Digital Branding</span>
      </div>
    </div>

    {/* TESTIMONIAL 6 */}
    <div className="dn-testimonial-card">
      <div className="dn-testimonial-stars">★★★★★</div>

      <p className="dn-testimonial-text">
        “The website was built with both performance and conversions in mind.
        The final result feels modern, professional, and user friendly.”
      </p>

      <div className="dn-testimonial-client">
        <h4>Recruitment Agency</h4>
        <span>Website Development</span>
      </div>
    </div>

  </div>

</section>


      {/* CONTACT INFO */}
      <section className="contact-info-section">
        <h2>Contact Information</h2>

        <div className="contact-methods">
          <a
            href="https://wa.me/254775137928"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp />
            WhatsApp
          </a>

          <a href="mailto:info@satimatechnova.co.ke">
            <FaEnvelope />
            info@satimatechnova.co.ke
          </a>

          <a href="tel:+254799090598">
            <FaPhoneAlt />
            +254 799 090 598
          </a>
        </div>

        <SocialLinks />
      </section>

      {/* FINAL CTA */}
      <section className="final-cta">
        <h2>Let's Grow Your Business Online</h2>

        <p>
          Whether you need a website, SEO, social media marketing, digital
          advertising, or custom software development, we're ready to help.
        </p>

        <a
          href="https://wa.me/254775137928"
          target="_blank"
          rel="noopener noreferrer"
          className="primary-btn"
        >
          Chat on WhatsApp
        </a>
      </section>

      <footer className="contact-footer">
        <p>📍 Serving businesses across Kenya</p>
        <p>📩 Transparent Pricing • Measurable Results • Real Growth</p>
      </footer>
    </main>
  );
};

export default Contact;